import React from 'react';

import MessageCard from 'bundles/assess-common/components/MessageCard';

import _t from 'i18n!nls/peer';

class AdministratorDeletedSubmissionStatusMessage extends React.Component {
  render() {
    return (
      <div className="rc-SubmissionDeletionStatusMessage">
        <MessageCard>
          <strong>{_t('An administrator has deleted your submission.')}</strong>
        </MessageCard>
      </div>
    );
  }
}

export default AdministratorDeletedSubmissionStatusMessage;
